// extracted by mini-css-extract-plugin
module.exports = {"container":"v0FlSl01dFdrYX4w5fzaG","icon":"_1Znfwt9VrgMW2q3YJAXLWS"};